module.exports = {
	"de-tal": {
		"errors": {
			"contact": {
				"not_found": "Dieser Kontakt existiert nicht"
			},
			"plans": {
				"free_trial": {
					"expired_title": "Ihre kostenfreie Testversion ist abgelaufen.",
					"expired_description": "Bitte klicken Sie auf den Button unten, um mit uns Kontakt aufzunehmen und Fanomena Talent weiterhin zu nutzen.",
					"expired_button": "Vertrieb Kontaktieren"
				},
				"not_allowed_modal": {
					"title": "Erweitern Sie Ihren Leistungsumfang.",
					"description": "Die von Ihnen gewählte Funktion ist in Ihrem aktuellen Leistungsumfang nicht verfügbar. Bitte kontaktieren Sie uns über den Chat oder über den untenstehenden Link und wechseln Sie ins nächste Paket.",
					"button": "Vertrieb Kontaktieren"
				},
				"not_found": "Bitte wählen Sie ein Paket."
			},
			"api_error_modal": {
				"no_name": "Kein Name",
				"select_company": "Wählen Sie das Unternehmen für Ihr Talent aus"
			},
			"emailtemplate": {
				"name": {
					"invalid": "Bitte trag einen Namen ein"
				},
				"body": {
					"invalid": "Bitte trag einen Text ein"
				}
			},
			"externalform": {
				"name": {
					"invalid": "Bitte trag einen Namen ein"
				},
				"language": {
					"invalid": "Bitte wähle eine Sprache"
				},
				"project_id": {
					"invalid": "Bitte wählen Sie eine Kampagne aus"
				}
			},
			"users": {
				"xls_import": {
					"wrong_file": "Bitte wähle eine gültige Datei"
				}
			},
			"organization": {
				"name": {
					"valid": "Bitte trag einen Namen ein"
				}
			},
			"authentication": {
				"empty_firstname": "Der Vorname ist leer. Bitte trag ein Vorname ein.",
				"empty_lastname": "Der Nachname ist leer. Bitte trag ein Nachname ein.",
				"empty_password": "Das Passwort ist leer. Bitte trag ein Passwort ein.",
				"logout": "Danke, dass Du Fanomena Talent benutzt hast. Bis bald.",
				"unauthorized": "Falsche Benutzername/Passwort Kombination! Der Benutzer konnte nicht angemeldet weden.",
				"wrong_email": "Das Format der E-Mail ist falsch",
				"wrong_jwt": "Deine Anmeldung ist abgelaufen. Bitte logge Dich erneut ein.",
				"wrong_password": "Das eingetragene Passwort ist ungültig. Bitte trage mindestens 8 Zeichen ein, wovon mindestens ein Buchstabe und eine Zahl enthalten sein muss.",
				"wrong_password_confirmation": "Die Passwörter stimmen nicht überein."
			},
			"base_score_error": "Die Basisbewertung sollte nur Zahlen enthalten",
			"compatibility": {
				"webcam": {
					"ios": "iPhone unterstützt die webcam API nicht. Bitte lade ein Bild aus Deiner Gallerie hoch.",
					"safari": "Vielen Dank für die Nutzung von Fanomena Talent. Für die beste Nutzung des Produkts zur Erfassung neuer Talente empfehlen wir unsere mobile App. Alternativ können Sie auch mit dem Browser Google Chrome fortfahren.",
					"firefox": "Vielen Dank für die Nutzung von Fanomena Talent. Bitte nutzen Sie als Browser Google Chrome, damit Sie auf alle Funktionalitäten von Fanomena Talent zugreifen können."
				}
			},
			"external_form": {
				"json": {
					"invalid": "Das json-Format ist ungültig."
				}
			},
			"lead": {
				"duplicate_email": "Diese E-Mail existiert bereits.",
				"email": {
					"empty": " ",
					"invalid": "",
					"taken": "Diese E-Mail Adresse existiert bereits"
				},
				"phone_company": {
					"invalid": "Ungültiges Format der Telefonnummer"
				},
				"wrong_tag_format": "Ein Tag kann nur aus Buchstaben und Zahlen bestehen."
			},
			"lead_mask": {
				"json": {
					"invalid": "Das json-Format ist ungültig."
				},
				"missing_elements": {
					"firstname": "Ihr Berichtsbogen hat kein \"Vorname\" Feld. Bitte fügen Sie es hinzu.",
					"lastname": "Ihr Berichtsbogen hat kein \"Nachname\" Feld. Bitte fügen Sie es hinzu.",
					"email": "Ihr Berichtsbogen hat kein \"E-Mail\" Feld. Bitte fügen Sie es hinzu."
				},
				"missing_values": "Ein Feld in Ihrem Berichtsbogen hat keine zusätzlichen Werte. Bitte fügen Sie mindestens eins hinzu."
			},
			"leadmask": {
				"name": {
					"invalid": "Bitte einen Namen eingeben"
				},
				"language": {
					"invalid": "Bitte gib eine Sprache an"
				}
			},
			"project": {
				"category": {
					"invalid": "Die Kategorie ist ungültig"
				},
				"end_date": {
					"invalid": "Das Enddatum ist ungültig"
				},
				"name": {
					"invalid": "Name ist ungültig"
				},
				"start_date": {
					"invalid": "Das Startdatum ist ungültig"
				},
				"not_found": "Die gesuchte Kampagne konnte nicht gefunden werden",
				"lead_mask_id": {
					"invalid": "Bitte wähle einen Berichtsbogen"
				}
			},
			"server_unreachable": "Der Server antwortet nicht",
			"unauthorized": "Die Seite die Du aufrufen willst ist für Dich gesperrt.",
			"token": {
				"invalid": "Dein Anmelde-Token ist ungültig oder abgelaufen"
			},
			"user": {
				"duplicate_email": "Diese E-Mail Adresse ist bereits registriert. Bitte wähle eine andere E-Mail.",
				"email": {
					"empty": "Die E-Mail Adresse fehlt",
					"invalid": "Die E-Mail Adresse ist ungültig"
				},
				"organization": {
					"invalid_plan": "Der Plan dieser Organisation ist ungültig oder abgelaufen."
				},
				"xls_import": {
					"wrong_file": "Diese Datei kann nicht verwendet werden"
				}
			}
		},
		"eventbaxx_event": {
			"association_mismatch": "Fehlercode'eventbaxx_event.association_mismatch'. Bitte kontaktieren unser Kundendienstteam.",
			"lead": {
				"email": {
					"invalid": "Das Business Kit kann nicht gesendet werden weil die E-Mailadresse fehlerhaft ist"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./hileadzz_i18n/talents/errors.de-tal.yml
// module id = 2035
// module chunks = 0